import Overview from "../../components/hellocians/Overview";
import { HellocianSidebarLayout } from "../../components/HellocianSidebar";

const ProjectManagementPage = () => {


  return (
          <HellocianSidebarLayout currentPath="/projects">
          <Overview/>
          </HellocianSidebarLayout>
  );
};

export default ProjectManagementPage;